import {gql} from "@apollo/client";
import { client } from "graphql/client";

export const HANDLE_NEW_ASSIGNMENT_OUT_FOR_DELIVERY = gql`
  mutation DeliveryMutation($input: OutForDeliveryInput!, $operatorName: String) {
    result: handleNewAssignmentOutForDeliveryEvent(input: $input, operatorName: $operatorName) {
        success
    }
  }
`;

export interface OutForDeliveryInput {
    orderId: string;
    location: {
        latitude: number;
        longitude: number;
    };
}

export interface OutForDeliveryVariables {
    input: OutForDeliveryInput;
    operatorName?: string | null;
}

interface OutForDeliveryResponse {  
    result: {
        success: boolean;
    };
}

export const handleNewAssignmentOutForDeliveryEvent = async (input: OutForDeliveryInput, operatorName?: string | null): Promise<boolean | undefined>  => {
    const { data } = await client.mutate<OutForDeliveryResponse, OutForDeliveryVariables>({
        mutation: HANDLE_NEW_ASSIGNMENT_OUT_FOR_DELIVERY,
        variables: { input, operatorName: operatorName || null },
    });
    return data?.result?.success;
};